import React from 'react';

import { Skeleton, SkeletonTheme, UiKit } from 'components';
import { usePreferredCarrier } from '../context';

export default function Loader({ children = null }) {
  const { isLoading } = usePreferredCarrier();

  if (!isLoading) return children;

  return (
    <SkeletonTheme className="m-0">
      <UiKit.Flex direction="column" gap={16}>
        <UiKit.Card>
          <UiKit.Card.Body>
            <UiKit.Flex gap={8}>
              <Skeleton circle width="16px" height="16px" className="my-1" />
              <UiKit.Flex direction="column">
                <Skeleton width="150px" height="16px" className="my-1" />
                <Skeleton width="400px" height="16px" />
              </UiKit.Flex>
            </UiKit.Flex>
          </UiKit.Card.Body>
        </UiKit.Card>
        <UiKit.Card>
          <UiKit.Card.Body>
            <UiKit.Flex gap={8}>
              <Skeleton circle width="16px" height="16px" className="my-1" />
              <UiKit.Flex direction="column">
                <Skeleton width="200px" height="16px" className="my-1" />
                <Skeleton width="360px" height="16px" />
              </UiKit.Flex>
            </UiKit.Flex>
          </UiKit.Card.Body>
        </UiKit.Card>
      </UiKit.Flex>
    </SkeletonTheme>
  );
}
